// Entry point for the build script in package.json
import "@hotwired/turbo-rails"
import "./controllers"
import { localizeTimes } from "./lib/viewer_time_zone"
import "./lib/appearance_sync"

// A broadcast card (a teammate's reply, a new comment) is rendered once for everyone on the
// thread, on the desk's zone. Re-print its stamps on this reader's before Turbo inserts it.
document.addEventListener("turbo:before-stream-render", (event) => {
  const template = event.target.querySelector(":scope > template")
  if (template) localizeTimes(template.content)
})

// Keep the service worker registered so Web Push can reach a closed tab, and so
// a deploy's updated worker is picked up without visiting Settings first.
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/service-worker.js")
  })
}
